import { parseQueryString } from '../utils/queryString';
import { useViewerRoute } from '../contexts/ViewerRoute';

import useMessageBoxClick from './mutation/messageBox/useMessageBoxClick';

const useHandleMessageBoxClick = () => {
  const { historyId, isBulk } = useViewerRoute();

  const { mutate: mutateMessageBoxClick } = useMessageBoxClick();

  const handleUserMessageBoxClick = (messageBoxId: number) => {
    mutateMessageBoxClick({
      messageBoxId,
      historyId: parseQueryString(historyId),
      isBulk,
    });
  };
  return {
    handleUserMessageBoxClick,
  };
};

export default useHandleMessageBoxClick;
